<template>
  <div class="page">
    <navigation-bar Close :name="data.name"/>
    <div class="main">
      <div class="coupon-top">
        <img :src="data.imgUrl">
        <el-row type="flex" justify="center" class="button-line mt-3">
          <el-button type="info" round v-show="data.convertEnable === 2"
                     @click="goExchange">
            我要兌換
          </el-button>
          <el-button type="primary" v-show="data.isGift === 1" class="donate-btn" round @click="goTransfer">
            <img src="@/assets/images/icon-card-trans.svg">轉贈
          </el-button>
        </el-row>
      </div>


      <div class="container pb-4">
        <div class="coupon-body">
          <!--    <div class="loyalty-card" v-if="data.userAmount >= 0">-->
          <!--      <div class="stamp active" v-for="item in data.userAmount" :key="item+'userAmount'">-->
          <!--       <el-image :src="data.pointImgUrl !== '' ? data.pointImgUrl : data.storeLogoImagePath" fit="cover"/>-->
          <!--      </div>-->
          <!--    </div>-->
          <div class="loyalty-card" v-if="data.pointsList.length > 0">
            <div class="stamp" v-for="(item, index) in data.pointsList" :key="index">
               <span class="day" :class="{ 'bg-red': item.diffDay <= 5 }">
                  <template v-if="item.diffDay>=1000000">{{item.diffText}}</template>
                  <template v-else-if="item.diffDay>=100">99<span class="plus">+</span>天</template>
                  <template v-else>{{item.diffDay}}天</template>
               </span>
              <el-image :src="data.pointImgUrl !== '' ? data.pointImgUrl : data.storeLogoImagePath" fit="cover"/>
            </div>
          </div>


          <div class="shadow-line"></div>

          <div class="UseBranch">
            <h6>適用分店</h6>
            <div class="branch-list" @click="gotoUsefulStoreList()">
                <span v-for="(item,index) in data.storeList" @click="gotoUsefulStoreList()" :key="index+'str'">
                  {{item.name === "" ? item.brandName : item.brandName+"-"+item.name}}
                </span>
            </div>
            <div class="arrow-btn" @click="gotoUsefulStoreList()"><i class="el-icon-arrow-right"/></div>
          </div>

          <div class="UseBranch">
            <h6>活動期限</h6>
            <div class="date">
              {{ data.activityStartAt }} ~ {{ data.activityEndAt }} 止
            </div>
          </div>

          <div class="UseBranch">
            <h6>兌換期限</h6>
            <div class="date">
              {{ data.useStartAt }} ~ {{ data.useEndAt }} 止
            </div>
          </div>
        </div>

        <div v-show="isShowContent(data.content)">
          <h6 class="mt-3">集點卡說明</h6>
          <p>{{data.content}}</p>
        </div>
        <div v-show="isShowContent(data.contentPrecautions)">
          <h6 class="mt-4">注意事項</h6>
          <p v-html="data.contentPrecautions"></p>
        </div>
      </div>
    </div>

    <loading
        :active.sync=isLoading
        :can-cancel="false"
        :is-full-page="true">
    </loading>

    <comm-dialog :value="isShowDialog" :outerContent="dialogMsg" :isCancel="false"
                 :appendToBody="isWeb"
                 @result="onDialogResult"/>

    <!--網頁版用-->
    <CommDialog :value="isShowDialogWeb"
                class="isWeb"
                :appendToBody="true"
                :isIcon="false"
                :isCancel="false"
                :outerContent="''"
                :isShowClose="true"
                @result="onCommDialogClose">
      <LoyaltyCardExchange isWeb :dataTokenWeb="dataToken" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='LoyaltyCardExchange'"/>
      <TransferLoyaltyCard isWeb :dataTokenWeb="dataToken" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='TransferLoyaltyCard'"/>
      <UsefulStoreList isWeb :dataTokenWeb="dataToken" @close="onCommDialogClose" class="web-content" v-if="isShowDialogWeb && isTypeWeb==='UsefulStoreList'"/>
    </CommDialog>
  </div>
</template>

<script>
import CommDialog from '@/components/CommDialog.vue';
import LoyaltyCardExchange from "@/views/gift/LoyaltyCardExchange";
import TransferLoyaltyCard from "@/views/gift/TransferLoyaltyCard";
import UsefulStoreList from "@/views/store/UsefulStoreList";


export default {
  name: "LoyaltyCardPage",
  props: {
    isWeb: Boolean,
    dataTokenWeb: {default: ''},
  },
  components: {
    CommDialog,
    LoyaltyCardExchange,
    TransferLoyaltyCard,
    UsefulStoreList,
  },
  data() {
    return {
      data: {
        userAmount :[],
        pointsList :[],
      },
      loyaltyCardId: '',
      isLoading: false,
      isShowDialog: false,
      dialogMsg: '',
      activeCategory: this.isWeb ? this.dataTokenWeb.activeCategory : this.$route.query.activeCategory,


      isShowDialogWeb: false,
      dataToken: '',
      isTypeWeb: '',

    }
  },
  created() {
    this.getLoyaltyCardInfo();
    this.loyaltyCardId = this.isWeb ? this.dataTokenWeb.id.toString() :this.$route.query.id.toString();
    this.changeIsRead();
  },
  mounted() {

  },
  methods: {
    changeIsRead: function () {
      if(typeof this.activeCategory === 'undefined' || this.activeCategory === '') return;
      this.$sqlite.delete('delete from gift_read  where gift_id = ? and type = ? ', [this.loyaltyCardId, this.activeCategory]);
    },
    getLoyaltyCardInfo() {
      this.isLoading = true;
      this.$http.fetchWithAuth`GetMyselfLoyaltyCardInfo${{
        'id': this.isWeb ? parseInt(this.dataTokenWeb.id) : parseInt(this.$route.query.id) ,
      }}
      ${json => {
        if (json.data !== null && json.data !== '') {
          this.data = json.data;
          //this.$route.meta.title = this.data.name;
        }
        this.isLoading = false;
      }
      }}`;
    },
    showDialog(msg) {
      this.dialogMsg = msg;
      this.isShowDialog = true;
    },
    onDialogResult() {
      this.isShowDialog = false;
    },
    gotoUsefulStoreList(id){
      if(!this.isWeb){
        this.$router.push({name: 'UsefulStoreList', query:{type: 'loyaltyCard', id: this.data.id}});
      }else {
        //單店網頁版用
        this.dataToken={type: 'loyaltyCard', id: this.data.id}
        this.isTypeWeb = 'UsefulStoreList'
        this.isShowDialogWeb = true
      }
    },

    /** 是否顯示活動說明 */
    isShowContent: function(content) {
      let result = this.$public.notNull(content) && (content !== '');
      return result;
    },

    goExchange(){
      if(!this.isWeb){
        this.$router.push({ name: 'LoyaltyCardExchange' , query: {id: this.loyaltyCardId}})
      }else {
        //單店網頁版用
        this.dataToken = {id: this.loyaltyCardId}
        this.isTypeWeb='LoyaltyCardExchange'
        this.isShowDialogWeb = true
      }
    },

    onCommDialogClose(result) {
      this.isShowDialogWeb = false;
      if(result){
        //有轉贈成功時頁面刷新
        window.location.reload();
      }
    },

    goTransfer(){
      if(!this.isWeb){
        this.$router.push({ name: 'TransferLoyaltyCard', params: {id: this.data.loyaltyCardUserId, loyaltyCardListId: this.$route.query.id} })
      }else {
        //單店網頁版用
        this.dataToken = {id: this.data.loyaltyCardUserId, loyaltyCardListId: this.dataTokenWeb.id}
        this.isTypeWeb='TransferLoyaltyCard'
        this.isShowDialogWeb = true
      }
    },
  }
}
</script>
<style lang="less" scoped src="../../less/gift.less"/>
